import React from "react";
import { Container } from "../../styles/container";
import styled from "styled-components";
import CustomButton from "../CustomButton";
const Content = styled.div`
  margin: 40px 0px;
  .campus {
    margin: 40px auto;
  }
  > h4 {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.4;
    color: var(--dark);
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  > p {
    font-size: 14px;
    color: var(--dark);
    line-height: 1.5;
    margin-bottom: 10px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
  > ul {
    margin-bottom: 12px;
    list-style: none;
    li {
      padding-left: 15px;
      font-size: 14px;
      line-height: 1.5;
      color: var(--dark);
      @media (max-width: 768px) {
        font-size: 12px;
      }
      > strong {
        width: max-content;
        white-space: nowrap;
        margin-right: 4px;
      }
    }
  }
`;
const MetaverseContent = () => {
  const handleNavigate = () => {
    window.open("https://alpharegiment.in/ssb-in-metaverse", "_blank");
  };

  return (
    <Container>
      <Content>
        <h2 className="main_heading">
          Revolutionizing Online Education with the Metaverse: A New Era of
          Learning
        </h2>
        <p>
          In traditional school and college settings, education goes beyond
          books and lectures. Students gain invaluable life skills such as
          teamwork, social interaction, environmental awareness, and emotional
          intelligence. These aspects play a significant role in shaping
          well-rounded individuals. However, in online education, these critical
          elements are often overlooked, leading to a gap in holistic learning.
          To bridge this gap and make online education more effective, the
          concept of using the metaverse comes into play. The metaverse has the
          potential to recreate the immersive, interactive, and social aspects
          of physical campuses in a virtual environment, ensuring students do
          not miss out on these essential experiences.
        </p>
        <h4>The Vision: Building Virtual Campuses for Aspiring Students</h4>
        <br />
        <p>
          With this innovative idea, we embarked on a mission to develop virtual
          campuses designed for different exams and educational purposes. These
          metaverse campuses aim to provide students preparing from home with an
          experience that mirrors the vibrancy and interactivity of physical
          learning hubs.
        </p>
        <p>
          For instance, consider <strong>Mukherjee Nagar</strong>, known as the
          epicenter for UPSC and SSC exam preparation in India. This vibrant
          locality is home to coaching institutes, study circles, and a buzzing
          environment where students thrive through collaboration and
          competition. A Metaverse Mukherjee Nagar could recreate this
          ecosystem, allowing aspirants to virtually interact, study, and
          collaborate with peers and mentors from the comfort of their homes.
        </p>
        <h4>Planned Metaverse Campuses</h4>
        <br />
        <p>
          We aim to develop multiple metaverse environments, each tailored to
          specific educational hubs or purposes:
        </p>
        <ul>
          <li>
            <strong>1. Metaverse Mukherjee Nagar:</strong>A virtual space for
            UPSC, SSC, and other government exam aspirants, complete with
            coaching sessions, study rooms, and peer interaction.
          </li>
          <li>
            <strong>2. Metaverse Silicon Valley:</strong>
            For tech enthusiasts, providing access to coding bootcamps,
            innovation hubs, and collaboration with industry leaders.
          </li>
          <li>
            <strong>3. Metaverse Kota:</strong>
            Emulating the famous coaching city for engineering and medical
            entrance exams, offering interactive physics, chemistry, and biology
            sessions in an immersive setting.
          </li>
          <li>
            <strong>4. Metaverse Alpha Regiment:</strong>A unique virtual campus
            for armed forces aspirants, integrating physical fitness sessions,
            SSB interview prep, medical guidance, and group tasks, simulating
            real-world SSB environments.
          </li>
        </ul>

        <h4>How the Metaverse Solves Real-World Problems</h4>
        <br />
        <ul>
          <li>
            <strong>1. Enhanced Interaction:</strong>
            Students can engage in group discussions, debates, and collaborative
            projects, mimicking real-world classroom dynamics.
          </li>
          <li>
            <strong>2. Immersive Learning:</strong>
            Advanced VR/AR technologies allow for realistic simulations, such as
            solving complex problems in a lab or participating in mock
            interviews.
          </li>
          <li>
            <strong>3. Social Networking:</strong>
            Aspirants can connect with peers, mentors, and experts from across
            the globe, building a supportive community.
          </li>
          <li>
            <strong>4. Accessible Education:</strong>
            Regardless of geographic location, students can access quality
            education and resources through these virtual campuses.
          </li>
        </ul>
        <h4>A Mission for the Future</h4>
        <br />
        <p>
          Our mission is not just to create virtual replicas of educational hubs
          but to transform the very essence of online learning. By integrating
          the metaverse into education, we aim to provide a holistic, engaging,
          and inclusive platform where students can thrive academically,
          socially, and emotionally. With this vision, we are laying the
          foundation for a future where education transcends physical barriers,
          ensuring every student has access to the tools and environment they
          need to succe
        </p>
        <CustomButton
          title="View Alpha Regiment Campus"
          onClick={handleNavigate}
          width="250px"

          className="campus"
        />
      </Content>
    </Container>
  );
};

export default MetaverseContent;
